import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Handles the Emergent OAuth callback.
 * On `/#session_id=...` we exchange the id for a session_token, then land the user on /.
 */
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { finaliseSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    // useRef guard — protects against React StrictMode double-invocation.
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const session_id = params.get("session_id");

    if (!session_id) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        await finaliseSession(session_id);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Auth exchange failed", e);
      } finally {
        // Clear the hash and land on home
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
      }
    })();
  }, [location, navigate, finaliseSession]);

  return (
    <main className="min-h-screen flex items-center justify-center bg-[#F7F3EA]">
      <div className="text-center">
        <div className="w-12 h-12 rounded-full border-2 border-[#1F4D3A]/20 border-t-[#1F4D3A] animate-spin mx-auto mb-4" />
        <p className="text-[#4A3728] font-serif text-lg">Setting up your journey…</p>
      </div>
    </main>
  );
}
